import { PreactDOMAttributes, h } from "preact";
import { UnitSystem } from "../../../shared/controller/unit-system-controller";
import { ILabelOptionValue, IOption } from "../../../typings";

interface ILabelSizingUnitSystemComponentProps extends PreactDOMAttributes {
  unitSystemOption: IOption;
  unitSystem: UnitSystem;
  setUnitSystem: (unitSystem: UnitSystem) => void;
  metricValue: ILabelOptionValue;
  imperialValue: ILabelOptionValue;
}

const LabelSizingUnitSystemComponent: (
  props: ILabelSizingUnitSystemComponentProps,
) => JSX.Element = ({
  children,
  unitSystemOption,
  unitSystem,
  setUnitSystem,
  metricValue,
  imperialValue,
}: ILabelSizingUnitSystemComponentProps): JSX.Element => (
  <div className="mb-8">
    {children}
    <p className="block py-4">
      {unitSystemOption.meta.fields?.unitOfMeasurement}
    </p>
    <button
      type="button"
      className={
        "bg-gray-light relative inline-flex justify-start text-base font-base flex-shrink-0 h-10 w-24 p-0.5 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      }
      role="switch"
      onClick={(e: InputEvent) =>
        setUnitSystem(
          unitSystem === UnitSystem.IMPERIAL
            ? (unitSystem = UnitSystem.METRIC)
            : (unitSystem = UnitSystem.IMPERIAL),
        )
      }
      aria-checked="false"
    >
      <div className="absolute flex w-full h-full text-gray-dark">
        <span className="flex items-center justify-center w-1/2 h-9">In</span>
        <span className="flex items-center justify-center w-1/2 h-9">Cm</span>
      </div>
      <span className="sr-only">Use setting</span>
      <span
        aria-hidden="true"
        className={`${
          unitSystem === UnitSystem.METRIC ? "translate-x-12" : "translate-x-0"
        } pointer-events-none h-9 w-1/2 flex items-center justify-center rounded-full bg-blue text-white shadow transform ring-0 transition ease-in-out duration-200`}
      >
        {unitSystem === UnitSystem.METRIC ? "Cm" : "In"}
      </span>
    </button>
  </div>
);

export default LabelSizingUnitSystemComponent;
